import React from "react";
import { AiOutlinePlusCircle } from "react-icons/ai";
import { Image, Row, Space, Table } from "antd";
import useLanguage from "../hooks/useLanguage";
import { useLoad } from "../hooks/request";
import { bannerDelete, bannerList } from "../utils/url";
import EditDrawerBtn from "../components/Atoms/Buttons/EditDrawerBtn";
import DeleteModalBtn from "../components/Atoms/Buttons/DeleteModalBtn";
import PostDrawerBtn from "../components/Atoms/Buttons/PostDrawerBtn";
import StatusTag from "../components/Atoms/StatusTag/StatusTag";
import { useGetTitle } from "../hooks/useGetTitle";

const BannerPage = () => {
  const { translateTitle } = useGetTitle();
  const getRequest = useLoad({ url: bannerList });
  const { response, loading } = getRequest;
  const translate = useLanguage();

  const columns = [
    {
      title: "Image",
      dataIndex: "image",
      render: (record) => (
        <Row align="middle" justify="center" style={{ width: 120, height: 60 }}>
          <Image
            width="100%"
            height="100%"
            src={record}
            alt="image"
            style={{ objectFit: "cover" }}
          />
        </Row>
      ),
    },
    {
      title: "Title",
      dataIndex: translateTitle("title"),
      key: "title",
      ellipsis: true,
    },
    {
      title: "Description",
      dataIndex: translateTitle("description"),
      key: "description",
      ellipsis: true,
      responsive: ["lg"],
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 120,
      render: (value) => <StatusTag value={value} />,
    },
    {
      title: "",
      key: "actions",
      width: 200,
      render: (_, record) => (
        <Space className="crud__actions">
          <EditDrawerBtn
            type={"banner"}
            data={record}
            request={getRequest.request}
          />
          <DeleteModalBtn
            url={bannerDelete}
            id={record._id}
            request={getRequest.request}
          />
        </Space>
      ),
    },
  ];

  return (
    <section className="page">
      <header className="page__header">
        <h1 className="page__title">Banners</h1>
        <PostDrawerBtn type={"banner"} request={getRequest.request}>
          <AiOutlinePlusCircle className="icon" />
          {translate("add-banner")}
        </PostDrawerBtn>
      </header>
      <div className="page__content">
        <Table
          columns={columns}
          dataSource={response?.data?.banners}
          scroll={{ x: "max-content" }}
          pagination={{
            pageSize: 10,
            total: response?.data?.pagination?.total,
            onChange: (page) => {
              getRequest.request({
                url: `${bannerList}?page=${page}&size=10`,
              });
            },
          }}
          loading={loading}
          rowKey="id"
        />
      </div>
    </section>
  );
};

export default BannerPage;
